import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Card, PageHeader, Button, Modal, Input, Select, Textarea, Spinner, EmptyState } from "@/components/common";
import { Plus, Trash2, Megaphone, Mail, Users } from "lucide-react";

export default function Comunicazioni() {
  const { can } = useAuth();
  const editable = can("comunicazioni", "edit");
  const [items, setItems] = useState(null);
  const [corsi, setCorsi] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ titolo: "", testo: "", target: "tutti", invia_email: false });

  const load = () => {
    api.get("/comunicazioni").then((r) => setItems(r.data)).catch((e) => toast.error(apiErr(e)));
    api.get("/corsi").then((r) => setCorsi(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);
  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const save = async () => {
    if (!form.titolo || !form.testo) { toast.error("Titolo e testo obbligatori"); return; }
    try { const { data } = await api.post("/comunicazioni", form); toast.success(form.invia_email ? `Inviata a ${data.email_count} destinatari` : "Comunicazione pubblicata"); setOpen(false); setForm({ titolo: "", testo: "", target: "tutti", invia_email: false }); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => { if (!window.confirm("Eliminare?")) return; await api.delete(`/comunicazioni/${id}`); load(); };

  if (!items) return <Spinner />;
  return (
    <div>
      <PageHeader title="Comunicazioni" subtitle="Avvisi a tutti, squadre o singoli — anche via email"
        actions={editable && <Button onClick={() => setOpen(true)} data-testid="add-comunicazione-btn"><Plus size={16} /> Nuova comunicazione</Button>} />
      {items.length === 0 ? <Card className="p-6"><EmptyState icon={Megaphone} title="Nessuna comunicazione" /></Card> : (
        <div className="space-y-3">
          {items.map((c) => (
            <Card key={c.id} className="p-5" data-testid={`comunicazione-${c.id}`}>
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-sky-50 grid place-items-center shrink-0"><Megaphone size={18} className="text-sky-600" /></div>
                  <div>
                    <h3 className="font-semibold text-slate-800">{c.titolo}</h3>
                    <p className="text-sm text-slate-600 mt-1 whitespace-pre-line">{c.testo}</p>
                    <div className="flex items-center gap-3 mt-2 text-xs text-slate-400">
                      <span className="flex items-center gap-1"><Users size={12} /> {c.target}</span>
                      {c.email_count > 0 && <span className="flex items-center gap-1 text-emerald-600"><Mail size={12} /> {c.email_count} email inviate</span>}
                      <span>· {c.sent_by}</span>
                    </div>
                  </div>
                </div>
                {editable && <button onClick={() => del(c.id)} className="p-1.5 rounded-lg hover:bg-red-50 text-red-500"><Trash2 size={15} /></button>}
              </div>
            </Card>
          ))}
        </div>
      )}
      <Modal open={open} onClose={() => setOpen(false)} title="Nuova comunicazione">
        <div className="space-y-4">
          <Input label="Titolo" data-testid="com-titolo" value={form.titolo} onChange={(e) => upd("titolo", e.target.value)} placeholder="Es. Allenamento annullato" />
          <Textarea label="Testo" rows={4} data-testid="com-testo" value={form.testo} onChange={(e) => upd("testo", e.target.value)} />
          <Select label="Destinatari" data-testid="com-target" value={form.target} onChange={(e) => upd("target", e.target.value)}>
            <option value="tutti">Tutti</option>
            {corsi.map((c) => <option key={c.id} value={`corso:${c.id}`}>Squadra: {c.nome}</option>)}
          </Select>
          <label className="flex items-center gap-2.5 cursor-pointer p-3 rounded-lg bg-slate-50 border border-slate-200">
            <input type="checkbox" data-testid="com-invia-email" checked={form.invia_email} onChange={(e) => upd("invia_email", e.target.checked)} className="w-4 h-4 accent-sky-600" />
            <span className="text-sm text-slate-600 flex items-center gap-1.5"><Mail size={15} /> Invia anche via email ai destinatari</span>
          </label>
          <div className="flex justify-end gap-2"><Button variant="ghost" onClick={() => setOpen(false)}>Annulla</Button><Button onClick={save} data-testid="save-comunicazione-btn">Pubblica</Button></div>
        </div>
      </Modal>
    </div>
  );
}
